'use strict';

angular.module('shiftTraderApp')
  .factory('UserAvailabilityChangeRequests', function (ServerUrls, Session, $http, TimeService, $injector, $q) {
    var STATE_MAPPING = {
      WAITING_FOR_AVAILABILITY_SET: 0,
      IN_REVIEW: 1,
      APPROVED: 2
    };

    var endpointName = 'user_availability_change_requests/';

    var UserAvailabilityChangeRequest = function(values) {
      var A = {};


      A.$initialize = function(initData) {
        angular.extend(A, initData);
        A.expiration_date = moment.utc(A.expiration_date).tz(Session.getTimezone());
        A.created_at = moment.utc(A.created_at).tz(Session.getTimezone());

        var ACR = $injector.get('AvailabilityChangeRequests');
        if (A.availability_change_request) {
          A.availability_change_request = ACR.initWithData(A.availability_change_request);
        }

        var AvailabilitySets = $injector.get('AvailabilitySets');
        if (A.availability_sets) {
          A.availability_sets = _.map(A.availability_sets, AvailabilitySets.initWithData);
        }
      };

      A.$initialize(values);


      A.$hasBeenRespondedTo = function() {
        return A.availability_sets.length > 0;
      };

      A.$pendingAvailabilitySet = function() {
        return _.find(A.availability_sets, function(availSet) {
          return availSet.$isPending() && availSet.active;
        });
      };

      A.$inReviewAvailabilitySet = function() {
        return _.find(A.availability_sets, function(availSet) {
          return availSet.$isInReview() && availSet.active;
        });
      };

      A.$approvedAvailabilitySet = function() {
        return _.find(A.availability_sets, function(availSet) {
          return availSet.$isApproved() && availSet.active;
        });
      };

      A.$hasPendingAvailabilitySet = function() {
        return _.any(A.availability_sets, function(availSet) {
          return availSet.active && availSet.$isPending();
        });
      };

      A.$hasInReviewAvailabilitySet = function() {
        return _.any(A.availability_sets, function(availSet) {
          return availSet.active && availSet.$isInReview();
        });
      };

      A.$hasApprovedAvailabilitySet = function() {
        return _.any(A.availability_sets, function(availSet) {
          return availSet.active && availSet.$isApproved();
        });
      };

      A.$isExpired = function(dt) {
        var testDt;
        if (dt) {
          testDt = dt;
        } else {
          testDt = TimeService.getNowInStoreTime();
        }

        return testDt.isAfter(A.expiration_date);
      };

      A.$statusInWords = function() {
        if (A.$hasBeenRespondedTo()) {
          if (A.$hasPendingAvailabilitySet()) {
            return 'Working on it';
          } else if (A.$hasInReviewAvailabilitySet()) {
            return 'Submitted';
          } else if (A.$hasApprovedAvailabilitySet()) {
            return 'Approved';
          } else {
            return 'Awaiting new response';
          }

        } else {
          // user has not replied
          return 'No response';
        }
      };






      A.$makeInactive = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          active: false
        })
          .then(function(response) {
            that.active = false;
            return response.data;
          }, function(response) {
            console.log('Error in UserAvailabilityChangeRequest.$makeInactive');
            return $q.reject(response);
          });
      };

      A.$approve = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          action: 'approve'
        })
          .then(function(response) {
            that.approved_by = response.data.approved_by;
            that.approved_by_user = response.data.approved_by_user;
            that.messages = response.data.messages;
            that.active = response.data.active;
            $rootScope.$broadcast('sa:availabilityRequestStateChange');
            return response.data;
          }, function(response) {
            console.log('Error in UserAvailabilityChangeRequest.$approve');
            return $q.reject(response);
          });
      };

      A.$disapprove = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          action: 'disapprove'
        })
          .then(function(response) {
            that.approved_by = response.data.approved_by;
            that.approved_by_user = response.data.approved_by_user;
            that.messages = response.data.messages;
            that.active = response.data.active;
            $rootScope.$broadcast('sa:availabilityRequestStateChange');
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      A.$sendMessage = function(messageText, usr) {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          message: {
            text: messageText,
            user_id: usr.id,
            user_first_name: usr.first_name,
            user_last_name: usr.last_name
          }
        })
          .then(function(response) {
            that.messages = response.data.messages;
            return response.data;
          }, function(response) {
            console.log('Error in UserAvailabilityChangeRequest.$approve');
            return $q.reject(response);
          });
      };

      return A;
    };

    var UserAvailabilityChangeRequests = {};

    UserAvailabilityChangeRequests.create = function (data) {
      return $http.post(ServerUrls.current.railsApi + endpointName, data)
        .then(function (response) {
          return new UserAvailabilityChangeRequest(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    UserAvailabilityChangeRequests.getById = function(theId) {
      return $http.get(ServerUrls.current.railsApi + endpointName + theId)
        .then(function(response) {
          return new UserAvailabilityChangeRequest(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    UserAvailabilityChangeRequests.getAll = function(params) {
      var config = {
        params: _.extend({}, params)
      };

      return $http.get(ServerUrls.current.railsApi + endpointName, config)
        .then(function(response) {
          return _.map(response.data, function(ar) {
            return new UserAvailabilityChangeRequest(ar);
          });
        }, function(response) {
          return $q.reject(response);
        });

    };

    UserAvailabilityChangeRequests.getAllApprovedDaysOff = function(extraParams) {
      var data = {
        //organization: 'primary',
        status: 'approved',
        type: 'daysoff',
        active: true
      };

      if (extraParams) {
        _.extend(data, extraParams);
      }

      return UserAvailabilityChangeRequests.getAll(data);
    };

    UserAvailabilityChangeRequests.getAllDaysOffNeedingApproval = function() {
      var data = {
        //organization: 'primary',
        status: 'awaitingapproval',
        type: 'daysoff',
        active: true
      };

      return UserAvailabilityChangeRequests.getAll(data);
    };

    UserAvailabilityChangeRequests.getRecentlyUpdatedOrNewDaysOff = function(params) {
      var data = {
        type: 'daysoff',
        mode: 'recent_new_or_updated'
      };

      angular.extend(data, params);

      return UserAvailabilityChangeRequests.getAll(data);
    };

    UserAvailabilityChangeRequests.initWithData = function(data) {
      return new UserAvailabilityChangeRequest(data);
    };

    UserAvailabilityChangeRequests.stateMapping = STATE_MAPPING;

    return UserAvailabilityChangeRequests;
  });
